export default __webpack_public_path__ + "static/media/Logo.f70ac0f3.svg";